<template>
	<fragment>
		<IconTracker v-if="shopView" />
		<RoundTracker v-if="!shopView" />
		<SpinTracker v-if="!shopView" />
		<BalanceTracker />
	</fragment>
</template>

<script>
import BalanceTracker from '@/components/game/header/BalanceTracker';
import IconTracker from '@/components/game/header/IconTracker';
import RoundTracker from '@/components/game/header/RoundTracker';
import SpinTracker from '@/components/game/header/SpinTracker';

export default {
	name: 'GameplayHeader',
	components: {
		BalanceTracker,
		IconTracker,
		RoundTracker,
		SpinTracker,
	},
	computed: {
		shopView() {
			return this.$route.matched.some(({ name }) => name === 'Shop');
		},
	},
};
</script>

<style lang="scss" scoped>
	.spin-tracker {
		position: absolute;
		top: 11px; // magic numer to account for border width
		left: 0;
		right: 0;
		margin: 0 auto;

		@include tablet {
			top: 13px; // magic numer to account for border width
		}

		@include desktop {
			top: 27px; // magic numer to account for border width
			left: unset;
			right: 0;
			margin-right: $spin-tracker-margin;
		}

		@include desktop-sm {
			top: 38px;
			margin-right: $spin-tracker-margin-sm;
		}
	}
</style>
